import actions from "@/lang/actions";
import buttons from "@/lang/buttons";
import confirmations from "@/lang/confirmations";
import datePresets from "@/lang/datePresets";
import dialogs from "@/lang/dialogs";
import errors from "@/lang/errors";
import filters from "@/lang/filters";
import formatters from "@/lang/formatters";
import hints from "@/lang/hints";
import inputs from "@/lang/inputs";
import legends from "@/lang/legends";
import links from "@/lang/links";
import messages from "@/lang/messages";
import placeholders from "@/lang/placeholders";
import roles from "@/lang/roles";
import routes from "@/lang/routes";
import tables from "@/lang/tables";
import titles from "@/lang/titles";
import tooltips from "@/lang/tooltips";

export default {
  locale: "en",
  ...actions,
  ...confirmations,
  ...titles,
  ...messages,
  ...links,
  ...buttons,
  ...errors,
  ...inputs,
  ...routes,
  ...tables,
  ...roles,
  ...dialogs,
  ...datePresets,
  ...legends,
  ...formatters,
  ...placeholders,
  ...tooltips,
  ...filters,
  ...hints,
};
